/** Statement page (balance history of one asset). */
export const statement = {
  title: "Statement",
  intro: "Every change to your available balance, like a bank statement: deposits credited, payouts reserved and released.",
  loadingOption: "Loading…",
  noNetworksTitle: "No networks enabled yet",
  noNetworksBody: "Enable a network on the Vault page to start receiving deposits.",
  noNetworksAction: "Go to Vault",
  availableNow: "Available now",
  caption: "Statement for {token}",
  emptyTitle: "No movements",
  emptyBody: "Nothing changed this balance in the selected period.",
  thisPage: "This page",

  // Columns
  time: "Time",
  description: "Description",
  reference: "Reference",
  in: "In",
  out: "Out",
  balance: "Balance",
  refDeposit: "Deposit",
  refPayout: "Payout",
  refTo: "To",
  refFrom: "From",
  refTx: "Transaction",

  /** Row descriptions by entry kind (API codes as keys); unknown kinds show the server's description. */
  kinds: {
    deposit_credit: "Deposit credited",
    payout_hold: "Payout reserved",
    payout_reserve: "Payout reserved",
    payout_release: "Payout released (failed or rejected)",
    payout_settle: "Payout sent",
    vault_topup: "Vault top-up",
    vault_withdrawal: "Vault withdrawal",
    adjustment: "Adjustment",
  },
};
